import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MaxWidthUIAlert = styled(UIAlert).withConfig({
  displayName: "EmbeddedCollapsedFlowAlert__MaxWidthUIAlert",
  componentId: "sc-5h30mz-0"
})(["max-width:50%;"]);
const EmbeddedCollapsedFlowAlert = ({
  href,
  onClick = () => {}
}) => /*#__PURE__*/_jsx(UIFlex, {
  justify: "center",
  className: "m-top-4",
  children: /*#__PURE__*/_jsx(MaxWidthUIAlert, {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.embed.flowCanvasContainer.collapsedEmbed.alert.title"
    }),
    type: "info",
    children: /*#__PURE__*/_jsxs(UIFlex, {
      direction: "column",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.embed.flowCanvasContainer.collapsedEmbed.alert.content"
      }), /*#__PURE__*/_jsx(UIButton, {
        className: "m-top-2",
        external: true,
        href: href,
        onClick: onClick,
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.embed.flowCanvasContainer.openInWorkflows.button"
        })
      })]
    })
  })
});
export default EmbeddedCollapsedFlowAlert;